import React, { useState, useEffect } from "react";
import {
  NavBarContainer,
  Logo,
  NavLinks,
  Register,
  Button,
  Menu,
  MenuOpen,
} from "./NavBar.styles";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/LogoCairo.svg";
import menu from "../../assets/images/menu.svg";
import closebtn from "../../assets/images/closebtn.svg";

function NavBar({ bg }) {
  const navigate = useNavigate();
  const [togglehide, setToggle] = useState(true);

  useEffect(() => {
    if (togglehide) {
      document.getElementById("mySidenav").style.width = "0px";
      document.getElementById("fakeNav").style.width = "0px";
    } else {
      document.getElementById("mySidenav").style.width = "414px";
      document.getElementById("fakeNav").style.width = "calc(100% - 250px)";
    }
  }, [togglehide]);

  return (
    <NavBarContainer bg={"#f5f8ff "}>
      {/* Logo */}
      {bg ? (
        <Logo>
          <img
            src={logo}
            alt=""
            id="kiwelogo"
            style={{ width: "80%", cursor: "pointer" }}
            onClick={() => {
              navigate("/");
            }}
          />
        </Logo>
      ) : (
        <Logo>
          <img
            src={logo}
            alt=""
            style={{ cursor: "pointer" }}
            id="kiwelogo"
            onClick={() => {
              navigate("/");
            }}
          />
        </Logo>
      )}
      {/* NavLinks */}
      <NavLinks togglehide={togglehide} id="TargetNavLink">
        <div id="Business" className="NavLink">
          <Link className="routerlink" to="/">
            <span>Home</span>
          </Link>
        </div>
        <div id="Personal" className="NavLink">
          <Link className="routerlink" to="/about-us">
            <span>Our Firm</span>
          </Link>
        </div>
        <div id="Blog" className="NavLink">
          <Link className="routerlink" to="/our-companies">
            <span>Our Verticals</span>
          </Link>
        </div>
      </NavLinks>
      {/* Register */}
      <Register id="TargetRegister">
        <Button
          onClick={() => {
            navigate("/contact-us", { state: { type: "" } });
          }}
          id="SignIn"
        >
          <span>Contact us</span>
        </Button>
      </Register>

      {togglehide ? (
        <MenuOpen onClick={() => setToggle(!togglehide)}>
          {" "}
          <img src={menu} alt="menu" />
        </MenuOpen>
      ) : (
        <Menu onClick={() => setToggle(!togglehide)}>
          <img src={closebtn} alt="menu" />
        </Menu>
      )}

      <div id="mySidenav" className="sidenav">
        <Logo
          style={{
            marginLeft: "2rem",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={logo}
            alt=""
            id="kiwelogo"
            style={{ width: "120px", height: "32px" }}
          />
        </Logo>

        <div
          onClick={() => setToggle(!togglehide)}
          id="fakeNav"
          className="fake_nav"
        ></div>
        <div id="Business" className="NavLink">
          <Link className="routerlink" to="/">
            <span>Home</span>
          </Link>
        </div>
        <div id="Personal" className="NavLink">
          <Link className="routerlink" to="/about-us">
            <span>Our Firm</span>
          </Link>
        </div>
        <div id="Blog" className="NavLink">
          <Link className="routerlink" to="/our-companies">
            <span>Our Verticals</span>
          </Link>
        </div>
        <div id="SignIn" className="NavLink">
          <Link className="routerlink" to="/contact-us">
            <span>Contact Us</span>
          </Link>
        </div>
      </div>
    </NavBarContainer>
  );
}

export default NavBar;
